import React from 'react'
import cn from 'classnames'
import ArrowRight from 'media/arrow-right.svg?svgr-webpack'
import { Link } from 'react-router-dom'

type GoalLinkProps = {
  name: string
  description: string
  image: {
    url: string
  }
  slug: string
}

function GoalLink({ name, description, slug, image }: GoalLinkProps) {
  return (
    <section
      className={cn(
        'bg-BgSub group relative lg:rounded-16',
        'flex flex-col items-center justify-between',
        'px-8 lg:px-12 py-12 lg:py-24',
        'type-14 md:type-17 lg:type-20',
        'border-l-2 first:border-BgSub border-white',
        'transition lg:border-3 lg:border-BgSub lg:hover:border-Border'
      )}
    >
      <div className="leading-default">
        <img
          src={image.url}
          alt=""
          style={{ height: 'min(20vw, 160px)' }}
          className={cn(
            'mb-16',
            name === 'Gain weight' && 'transform scale-125 origin-bottom'
          )}
        />
        <h1 className="font-demibold mb-4">{name}</h1>
        <p className="hidden md:block leading-body">{description}</p>
      </div>
      <Link
        to={`/nutrition-explained/category/${slug}`}
        className="mt-16 fill-link bg-green rounded-full h-32 w-32 lg:h-40 lg:w-40 shadow-elevated transition group-hover:bg-green-darker flex"
      >
        <ArrowRight className="text-white m-auto" />
      </Link>
    </section>
  )
}

type Props = {
  goals: any[]
}
export default function NutritionStartGoal({ goals }: Props) {
  return (
    <div className="grid grid-cols-3 gap-0 lg:gap-4 xl:gap-6 -mx-20 lg:mx-0">
      {goals.map((goal) => (
        <GoalLink key={goal.id} {...goal} />
      ))}
    </div>
  )
}
